import { getCookie, setCookie, useCookie } from "../hooks";
import { standardJsonCodec } from "../codecs/sync/json";
import { withFallback } from "../codecs/sync/algebra";
const DEFAULT = { lang: "en" };
const NAME = "opp";
const OPTIONS = {
    days: 365,
};
export const CODEC = withFallback(standardJsonCodec(), DEFAULT);
export function getOppCookie() {
    return CODEC.decode(getCookie(NAME) ?? "");
}
export function setOppCookie(cookie) {
    setCookie(NAME, CODEC.encode(cookie), OPTIONS);
}
export function useOppCookie() {
    return useCookie(CODEC, NAME, OPTIONS);
}
//# sourceMappingURL=opp.js.map